<template>
    <div class="self-intro">
		<Loading v-if="!loadingDone"/>
        <div class="title">作品及获奖介绍</div>
        <div class="textarea-box">
            <textarea v-model="textAreaContent"></textarea>
            <p :class="{'colorRed':textCount>=500}">{{textCount}}/500</p>
        </div>
        <p class="error-message">{{errorMsg}}</p>
        <div class="submit-btn" @click="updateUserInfo('prize',textAreaContent)">确定</div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name:'Prize',
    data(){
        return{
            textCount:0,                     //输入框字数统计
			textAreaContent:'',		         //输入框内容
			errorMsg:'',                     //错误信息 
			loadingDone:false                //加载页面显示隐藏
        }
	},
	created(){
		Axios.get('/user/info').then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.textAreaContent=response.data.data.prize
                    this.loadingDone=true
                }
            }
        ).catch(
            error=>{
                this.$swal({
					text:'网络错误 请稍后重试',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
            }
        )
	},
    watch:{
        'textAreaContent':function(val){
            this.textCount=val.length
        }
    },
    methods:{
        updateUserInfo(infokey,infoValue){
            if(infoValue==""){
                this.errorMsg="请输入您的作品及获奖介绍"
                return
            }
            if(this.textCount>500){
                this.errorMsg="超出长度限制"
                return
            }
            let updateInfo={}
            updateInfo[infokey]=infoValue
            Axios.post('/user/update',updateInfo)
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.$router.go(-1)
                    }
                }
            ).catch(
                error=>{
                    this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					})
                }
            )
        }
	},
	components:{
		Loading
	}
}
</script>

<style scoped lang="scss">
    .self-intro{
        padding:40px 56px;
        padding-top:148px;
        .title{
            font-size:26px;
            color:#222;
            margin-bottom:30px;
            font-weight:bold;
        }
        .textarea-box{
            width:638px;
            height:390px;
            background:#f7f7f7;
            border-radius:30px;
            textarea{
                height:300px;
                width:598px;
                background:#f7f7f7;
                border:none;
                border-radius:30px 30px 0 0;
                padding:20px;
                font-size:24px;
                color:#222;
            }
            p{
                font-size:24px;
                height:26px;
                line-height:26px;
                padding:0px 30px;
                color:#999;
                text-align:right;
                background:#f7f7f7;
            }
            .colorRed{
                color:#bf0000;
            }
        }
        .error-message{
            margin-bottom:60px;
        }
        .submit-btn{
            width:638px;
            height:70px;
            line-height:70px;
            text-align:center;
            background:#bf0000;
            border-radius:35px;
            color:#fff;
            font-size:24px;
        }
        .submit-btn:active{
            background:#DD8080;
        }
    }
</style>